export const locale = {
  lang: 'es',
  data: {
    'AVANCES': {
      'GOSURVEY':'Ir a la encuesta',
      'GOPORTAL':'Ir al portal de conteos',
      'REGRESAR':'Regresar',
      'DESCARGAR':'Descargar excel',
      'PRIMEROS':'Primeros 1000',
      'SINCRONIZAR':'Sincronizar con portal de conteos',
      'AGREGAR': 'Agregar',
      'PRODUCTO':'Producto',
      'FEC-LAN':'Fecha de lanzamiento',
      'FEC-CIE':'Fecha de cierre',
      'NOFEC-LAN': "Aún no tiene una fecha de lanzamiento programada",
      'FEC-CIE-PROR':'Fecha de cierre prorroga',
      'CER':'Cerrar Encuesta',
      'ABR':'Abrir Encuesta',
      'SURVEY':'Encuesta: ',
      'FILE':'Cultura Go y Gestor de archivos: ',
      'PROR':'PRORROGA',
      'WARNING-FECHA-GUARDAR':'Estas seguro de agregar prorroga con fecha ',
      'SUCCESS-PRORROGA': 'Se ha cambiado la fecha de cierre ',
      'WARNING-CIERRE-ENCUESTA':'Estas seguro de cambiar el estatus de la encuesta?',
      'SUCCESS-CIERRE': 'La encuesta se cambio correctamente',
      'PORCENTAJE':'Avance de respuestas: ',
      'DES':'Clic para ver    ',
      'WARNING-BTN':'No se puede realizar esta acción ya que su encuesta no ha sido lanzada',
      'PROCESARRESU': 'Procesar resultados',
      'ETIQUETAS':{
        'ETIQUETAS': 'Muestras por página',
        'OF': 'de',
      },
      'BOTONES-MODALES':{
        'ELIMINAR':{
          'MESSAGE1':'<span>Para confirmar la eliminación de las respuestas del usuario ',
          'MESSAGE2':', ingrese el nombre en la caja de texto</span>',
          'MESSAGE3':'<span>Para confirmar la eliminación de las respuestas del usuario, ingrese el nombre en la caja de texto ',
          'SALIR': 'Salir',
          'VALIDAR': 'Confirmar usuario',
          'ERRORNOMBREEMPRESA': 'El nombre del usuario ingresado, no coincide con el nombre del usuario que desea eliminar',
          'MENSAJE': '¿Está seguro?\n\nEstá a punto de borrar las respuestas del usuario ',
          'CANCELAR': 'Cancelar',
          'CONFIRMAR': 'Si, eliminar',
          'SUCCES': 'Respuestas eliminadas',
          'CERRAR': 'Cerrar'
        },
        'MESSAGE':'¿Seguro que desea eliminar las respuestas del usuario ',

        'RESP_SI':'Sí',
        'RESP_NO':'No',
        'ACEPTAR':' Aceptar',
        'CANCELAR':'Cancelar',
        'SUCCESS-DELETE':'Respuestas eliminadas',
        'ERROR-DELETE':'Ocurrio un error',
        'OK':'Ok',
      },
      'PROCESAR': {
        'OK': 'El proceso se inició correctamente',
        'NOTOK': 'El proceso no pudo comenzar, primero necesita configurar los resultados deseados'
      },
      'INS':{
        'INS1':' de ',
        'INS2':' colaboradores '
      },
      'INICIO':{
        'TITULO':'Estado de encuesta por usuarios',
        'INSTRUCCIONES':'De lado izquierdo se muestra una barra con los productos adquiridos por la empresa. Al dar clic a uno de ellos se muestran los productos por años, por favor seleccionar unos para poder mostrar la lista de usuarios que están realizando la encuesta de dicho producto.',
      },
      'ENCUESTA':{
        'TTITULO': 'Avance de encuestas por usuario',
        'PRODUCTS':'Productos adquiridos',
        'LABEL01':'Nombre',
        'LABEL02':'Correo',
        'LABEL03':'Clave',
        'LABEL04':'Estado',
        'LABEL05':'Invitación',
        'LABEL06':'Recordatorio',
        'LABEL07':'Eliminar',
        'LABEL08':'Inicio',
        'LABEL09':'Fin',
        'LABEL10':'Acciones de usuario',
        'LABEL11':'Acciones de encuesta',
        'LABEL12':'Clave de Acceso',
        'DESCARGAR':'Descargando, por favor espere...',
        'BUSCAR':'Buscar',
        'TITULOEXCEL':'Estatus de encuesta',
        'CARGANDO':'Cargando',
        'ACTIVA':'Encuesta no habilitada',
        //, por favor espere.... el total de usuarios que tiene es:
        'PLACE':'Escriba el nombre del colaborador que desee buscar',
        'ACTIONS':'Acciones especiales',
        'NOUSER':'Búsqueda no encontrada',
        'NA':'Sin información',
        'ERROR':'Este producto aún no tiene una encuesta creada',
        'SUCCESS1':'Invitación enviada',
        'SUCCESS2':'Recordatorio enviado',
        'ERROR1':'Ha ocurrido un error',
      },
      'TITULOS':{
        'NAME':'Nombre del colaborador',
        'ESTADOS':'Estado de la encuesta',
        'FECHA1':'Fecha de inicio',
        'FECHA2':'Fecha en que termino la encuesta',
        'ESTADOS_ENC':{
          'TITULO':'Selecciona una opción',
          'TODO':'Mostrar todo',
          'ESTADO1':'No ha iniciado la encuesta',
          'ESTADO2':'Ha iniciado sesión',
          'ESTADO3':'Encuesta en progreso',
          'ESTADO4':'Encuesta finalizada',
          'ESTADO5':'No Aceptada',
          'ESTADO6':'Acepto la encuesta',

        }
      },
      'COLUMNAS':{
        'email':'Correo electrónico',
        'end_date':'Fecha final',
        'id_status':'Estado',
        'name':'Nombre',
        'start_date':'Fecha de inicio'
      },
      'ACCIONES_EMAIL':{
        'ACCIONES':'Acciones en encuesta',
        'INFO':'La siguiente lista muestra la lista de acciones permitidas para el usuario',
        'ACC1':'Reenviar invitación',
        'ACC2':'Reenviar recordatorio',
        'ACC3':'Eliminar respuesta de encuesta',
      },
      'NEWCOLAB': {
        'TITULO': 'Agregar nuevo colaborador a la encuesta',
        'INST_1': 'Complete cada uno de los conjuntos de datos requeridos para agregar un nuevo colaborador',
        'TITULO_MOD': 'Modificar datos del colaborador',
        'INST_1_MOD': 'Puede realizar modificaciones a cada uno de los conjuntos de datos del colaborador seleccionado',
        'INST_2': 'Los campos marcados con (*) son obligatorios',
        'WARNING1':'NOTA: LA CLAVE ESTE ESTE COLABORADOR ',
        'WARNING2':'  NO PUEDE SER MODIFICADA',
        'DATASET_1': 'Conjunto 1',
        'DATASET_2': 'Conjunto 2',
        'DATASET_3': 'Conjunto 3',
        'DATASET_4': 'Conjunto 4',
        'DATASET_5': 'Conjunto 5',
        'DATASET_6': 'Conjunto 6',
        'DATASET_7': 'Conjunto 7',
        'REQUIRED': 'Este campo es obligatorio',
        'NEXT': 'Siguiente',
        'BACK': 'Anterior',
        'SAVE': 'Guardar',
        'ERR_OWNKEY': 'El número de empleado introducido ya se encuentra almacenado en la base de datos, intente con uno diferente',
        'ERR_BOSSKEY': 'El número de jefe introducido no se encuentra almacenado en la base de datos, intente con uno diferente',
        'ERR_VAL_1': 'El dato introducido en el campo: ',
        'ERR_VAL_2': ' contiene caracteres no permitidos, o no cuenta con el formato correcto',
        'GUARDANDO': 'Se está almacenando la información del colaborador, espere por favor',
        'GUARDANDO_GOFLOW': 'Se está almacenando la información, espere por favor',
        'SAVE_OK': 'La información del nuevo colaborador se ha almacenado correctamente',
        'MOD_OK': 'La información del colaborador se ha modificado correctamente',
        'FORMULARIO': 'Aún no ha completado el formulario de registro, revise que ha llenado todos los campos obligatorios y vuelva a intentarlo',
        'ACCIONES': 'Acciones',
        'VERACT': 'Acciones de usuarios',
        'LOADACT': 'Cargando acciones disponibles',
        'NOACT': 'No se pueden realizar acciones adicionales para este colaborador',
        'AVAACT': 'Se pueden realizar las siguientes acciones para el colaborador',
        'ACCIONLIST': {
          'modificar': 'Modificar los datos del colaborador seleccionado',
          'borrar': 'Borrar el colaborador seleccionado'
        },
        'DELCOLAB': '¿Confirma eliminar el colaborador seleccionado de este producto? Nota: Esta acción no se puede revertir',
        'DEL_OK': 'El colaborador se eliminó correctamente del producto',
        'ERR_EMAIL': 'El correo electrónico introducido ya se encuentra almacenado en la base de datos, intente con uno diferente',
        'ERR_SAMEKEY': 'La clave de jefe introducida y la clave de colaborador son iguales, esto no está permitido, intente con una clave diferente',
        'RESET_COLAB_SURVE': '¿Confirma resetear el acceso a la encuesta? ',
        'ACTU_OK': 'Se actualizo correctamente',
      },
      'FORMULARIO_GO_FLOW':{
        'perspective': 'Perspectiva',
        'statementID': 'Reactivo ID',
        'dimensionL1': 'Dimensión L1',
        'dimensionL2': 'Dimensión L2',
        'survey_Score_OverallTI': 'Encuesta Puntuación GlobalTI',
        'company_Country': 'Pais empresa',
        'cgo_Product_Name': 'Nombre de producto cgo',
        'company_Name': 'Nombre de empresa',
        'ranking_Year': 'Año de ranking',
        'survey_Respondents': 'Encuestados',
        'survey_Score_Camaraderie': 'Encuesta Puntuación Compañerismo',
        'survey_Score_Credibility': 'Encuesta Puntuación Credibilidad',
        'survey_Score_Imparciality': 'Encuesta Puntuación Imparcialidad',
        'survey_Score_Pride': 'Encuesta Puntuación Orgullo',
        'survey_Score_Respect': 'Encuesta Puntuación Respeto',
        'survey_Score_Gestalt': 'Encuesta Puntuación Gestalt',
        'pdf_DateCreation': 'Fecha creación certificado',
        'WARNI_TI_DA':'El valor ingresado no corresponde con el formato permitido (100.00)',
        'WARNI_TI_DA_GRAL':'Los datos ingresados no estan en el formato establecido',
        'numUsers': 'Colaboradores'
      },
      'FORMULARIO':{
        'fullName': 'Nombre del colaborador',
        'ownKey': 'Número / Clave del colaborador',
        'age': 'Año de nacimiento',
        'surveyKey': 'Clave para ingresar a la encuesta',
        'email': 'Correo electrónico',
        'bossName': 'Nombre del Jefe directo',
        'bossKey': 'Número / Clave Jefe directo',
        'country': 'País',
        'location': 'Localidad',
        'geo_1': 'Nivel geográfico 1',
        'geo_2': 'Nivel geográfico 2',
        'geo_3': 'Nivel geográfico 3',
        'geo_4': 'Nivel geográfico 4',
        'geo_5': 'Nivel geográfico 5',
        'geo_6': 'Nivel geográfico 6',
        'geo_7': 'Nivel geográfico 7',
        'geo_8': 'Nivel geográfico 8',
        'geo_9': 'Nivel geográfico 9',
        'geo_10': 'Nivel geográfico 10',
        'geo_19': 'Nivel geográfico 19',
        'structure_1': 'Nivel estructural 1',
        'structure_2': 'Nivel estructural 2',
        'structure_3': 'Nivel estructural 3',
        'structure_4': 'Nivel estructural 4',
        'structure_5': 'Nivel estructural 5',
        'structure_6': 'Nivel estructural 6',
        'structure_7': 'Nivel estructural 7',
        'structure_8': 'Nivel estructural 8',
        'structure_9': 'Nivel estructural 9',
        'structure_10': 'Nivel estructural 10',
        'area': 'Área',
        'bUnit': 'Unidad de negocio',
        'enterDate': 'fecha de ingreso (dd/mm/aaaa)',
        'antiquity': 'Antigüedad',
        'antiquityUS': 'Antigüedad US',
        'generation': 'Generación',
        'generationUS': 'Generación US',
        'ageUS': 'Edad',
        'charge': 'Cargo o función en la Empresa',
        'homologado': 'Cargo o función homologado',
        'homologadoUS': 'Cargo o función homologado US',
        'gender': 'Género',
        'genderType': 'Tipo de género',
        'typeofwork': 'Esquema de compensación',
        'workCondition': 'Condición de trabajo',
        'academico': 'Grado académico',
        'contratacion': 'Tipo de contratación',
        'situacionUS': 'Situación laboral US',
        'personal': 'Tipo de personal',
        'jornada': 'Tipo de jornada de trabajo',
        'rotacion': 'Rotación de turnos',
        'phone': 'Teléfono',
        'extension': 'Extensión',
        'cellphone': 'Número de celular',
        'native': 'Idioma materno',
        'answer': 'Responde',
        'other_1': 'Otros 1',
        'other_2': 'Otros 2',
        'other_3': 'Otros 3',
        'other_4': 'Otros 4',
        'other_5': 'Otros 5',
        'other_6': 'Otros 6',
        'other_7': 'Otros 7',
        'other_8': 'Otros 8',
        'other_9': 'Otros 9',
        'other_10': 'Otros 10',
      },
      'SINCRONIZACION':{
        'SINCRONIZANDO':'Sincronizando con portal de conteos, por favor espere...',
        'SUCCESS':'Sincronización completada correctamente'
      }
    },
  }
};
